//styles/recipeStyles.js

export const recipeListContainer = (theme) => ({
  padding: {
    xs: theme.spacing(1),
    sm: theme.spacing(2),
  },
});
export const recipeGridItem = (theme) => ({
  display: "flex",
  justifyContent: "center",
});

export const cardTitle = (theme) => ({
  position: "absolute",
  bottom: 10,
  left: 0,
  right: 0,
  textAlign: "center",
  background: "rgba(0, 0, 0, 0.5)",
  color: theme.palette.primary.contrastText,
  padding: theme.spacing(1),
  fontSize: "1.2rem",
  fontWeight: 600,
  transition: "background 0.3s",
});

export const cardDescription = (theme) => ({
  color: theme.palette.text.secondary,
  minHeight: 48,
  maxHeight: 48,
  overflow: "hidden",
  textOverflow: "ellipsis",
});

export const tagListContainer = (theme) => ({
  padding: theme.spacing(1),
  maxHeight: 60,
  overflowX: "auto",
  overflowY: "hidden",
});

//  TagList Styles
export const tagListWrapper = (theme) => ({
  flexWrap: "nowrap",
  overflowX: "auto",
  scrollbarWidth: "none",
  "&::-webkit-scrollbar": {
    display: "none",
  },
  [theme.breakpoints.down("sm")]: {
    justifyContent: "center",
  },
  [theme.breakpoints.up("md")]: {
    justifyContent: "flex-start",
  },
});

export const tagChip = (theme) => ({
  height: 24,
  fontSize: 12,
  padding: "0 6px",
  whiteSpace: "nowrap",
  flexShrink: 0,
  backgroundColor: theme.palette.secondary.main,
  color: theme.palette.secondary.contrastText,
  "&:hover": {
    backgroundColor: theme.palette.secondary.dark,
  },
});

export const recipePageStyles = (theme) => ({
  subtleBackground: {
    backgroundColor: theme.palette.background.subtle,
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    borderRadius: theme.shape.borderRadius,
  },
  imageStyle: {
    width: "100%",
    borderRadius: theme.shape.borderRadius,
  },
  titleBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    marginBottom: theme.spacing(2),
  },
});

export const recipeCard = (theme) => ({
  width: 345,
  height: 380,
  display: "flex",
  flexDirection: "column",
  justifyContent: "space-between",
  margin: theme.spacing(1),
  boxShadow: theme.shadows[3],
  transition: "transform 0.3s, box-shadow 0.3s",
  position: "relative",
  overflow: "hidden",
  cursor: "pointer",
  backgroundColor: theme.palette.background.subtle,
  "&:hover": {
    transform: "scale(1.03)",
    boxShadow: theme.shadows[6],
  },
});

export const recipeCardMedia = (theme) => ({
  objectFit: "cover",
  width: "100%",
  height: "100%",
});

export const hoverActionsContainer = (theme) => ({
  position: "absolute",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  background: "rgba(0, 0, 0, 0.3)",
  opacity: 0,
  transform: "translateY(10px)",
  transition: "opacity 0.3s, transform 0.3s",
});

export const favoriteButton = (theme, isMarked, isAuthenticated) => ({
  backgroundColor: isAuthenticated ? (isMarked ? theme.palette.primary.main : theme.palette.secondary.main) : theme.palette.grey[400], // Greyed out when not authenticated
  color: isAuthenticated ? (isMarked ? theme.palette.primary.contrastText : theme.palette.secondary.contrastText) : theme.palette.grey[600],
  cursor: isAuthenticated ? "pointer" : "not-allowed",
  opacity: isAuthenticated ? 1 : 0.6,
  transition: "background 0.3s ease",
  padding: theme.spacing(1),
  borderRadius: "50%",
  fontSize: 24,
  position: "relative",
});

export const actionButton = (theme) => ({
  margin: theme.spacing(1),
  backgroundColor: "rgba(255, 255, 255, 0.8)",
  color: theme.palette.primary.main,
  "&:hover": {
    backgroundColor: theme.palette.primary.light,
  },
});
